import { render, staticRenderFns } from "./BundleGroupCard.vue?vue&type=template&id=eb8cd5f6&scoped=true&"
import script from "./BundleGroupCard.vue?vue&type=script&lang=ts&"
export * from "./BundleGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./BundleGroupCard.vue?vue&type=style&index=0&id=eb8cd5f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8cd5f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
